import styled from 'styled-components';

export const TeamWidgetContainer = styled.div`
  background: ${(props) => props.theme.mainBackgorund};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  border-radius: 2px;
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
`;

export const TeamsWidgetHeader = styled.div`
  background: ${(props) => props.theme.bonusPaidDaysBackground};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  border-bottom: 2px solid ${(props) => props.theme.dividerMainColor};

  position: relative;
  @media (max-width: 710px) {
    position: static;
  }
`;

export const TeamWidgetTitle = styled.h2`
  display: flex;
  gap: 0.5rem;
  font-weight: 600;
  padding-left: 0.5rem;
  color: ${(props) => props.theme.textMainColor};
  div:first-child {
    cursor: pointer;
  }
  cursor: default;
`;

export const TeamWidgetListFooter = styled.li`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0.75rem 2rem !important;
  border-top: 1px solid #d1d1d1;

  p {
    color: #5b5fc7;
    cursor: pointer;
  }
`;
